import type { RouteObject } from 'react-router';
import { internalNav } from '@/lib/nav/internal';
import { collectRoutes } from '../routes';

const modules = import.meta.glob<{ routes: RouteObject[] }>('./*/routes.tsx', { eager: true });

export const internalRoutes = collectRoutes(modules, internalNav, '/internal');
